export const BACKSPACE = 8;
export const TAB = 9;
export const ENTER = 13;
export const SHIFT = 16;
export const CTRL = 17;
export const ALT = 18;
export const PAUSE_BREAK = 19;
export const CAPS_LOCK = 20;
export const ESCAPE = 27;
export const PAGE_UP = 33;
export const PAGE_DOWN = 34;
export const END = 35;
export const HOME = 36;
export const LEFT_ARROW = 37;
export const UP_ARROW = 38;
export const RIGHT_ARROW = 39;
export const DOWN_ARROW = 40;
export const INSERT = 45;
export const DELETE = 46;
export const ZERO = 48;
export const ONE = 49;
export const TWO = 50;
export const THREE = 51;
export const FOUR = 52;
export const FIVE = 53;
export const SIX = 54;
export const SEVEN = 55;
export const EIGHT = 56;
export const NINE = 57;
export const A = 65;
export const B = 66;
export const C = 67;
export const D = 68;
export const E = 69;
export const F = 70;
export const G = 71;
export const H = 72;
export const I = 73;
export const J = 74;
export const K = 75;
export const L = 76;
export const M = 77;
export const N = 78;
export const O = 79;
export const P = 80;
export const Q = 81;
export const R = 82;
export const S = 83;
export const T = 84;
export const U = 85;
export const V = 86;
export const W = 87;
export const X = 88;
export const Y = 89;
export const Z = 90;
export const LEFT_WINDOW_KEY = 91;
export const RIGHT_WINDOW_KEY = 92;
export const SELECT_KEY = 93;
export const NUMPAD_0 = 96;
export const NUMPAD_1 = 97;
export const NUMPAD_2 = 98;
export const NUMPAD_3 = 99;
export const NUMPAD_4 = 100;
export const NUMPAD_5 = 101;
export const NUMPAD_6 = 102;
export const NUMPAD_7 = 103;
export const NUMPAD_8 = 104;
export const NUMPAD_9 = 105;
export const MULTIPLY = 106;
export const ADD = 107;
export const SUBTRACT = 109;
export const DECIMAL_POINT = 110;
export const DIVIDE = 111;
export const F1 = 112;
export const F2 = 113;
export const F3 = 114;
export const F4 = 115;
export const F5 = 116;
export const F6 = 117;
export const F7 = 118;
export const F8 = 119;
export const F9 = 120;
export const F10 = 121;
export const F11 = 122;
export const F12 = 123;
export const NUM_LOCK = 144;
export const SCROLL_LOCK = 145;
export const SEMI_COLON = 186;
export const EQUAL_SIGN = 187;
export const COMMA = 188;
export const DASH = 189;
export const PERIOD = 190;
export const FORWARD_SLASH = 191;
export const GRAVE_ACCENT = 192;
export const OPEN_BRACKET = 219;
export const BACK_SLASH = 220;
export const CLOSE_BRACKET = 221;
export const SINGLE_QUOTE = 222;
export const NONE = 9999;

export const MODIFIER_KEYS = [NONE, CTRL, SHIFT];

// prettier-ignore
export const SHORTCUT_KEYS = [
    F1, F2, F3, F4, F5, F6, F7, F9, F10, F11, F12,
    NUMPAD_0, NUMPAD_1, NUMPAD_2, NUMPAD_3, NUMPAD_4, NUMPAD_5, NUMPAD_6, NUMPAD_7, NUMPAD_8, NUMPAD_9,
    A, B, C, D, E, F, G, H, I, J, K, L, M, N, O, P, Q, R, S, T, U, V, W, X, Y, Z
];
